// Auto-generated by scripts/generate-public-snapshot.js — do not edit.
// Each page / entity is its own module so webpack emits a per-page chunk;
// the client only downloads snapshot data for routes it actually visits.

export const generatedAt: string | null = "2026-10-06T07:04:00.826Z";

export const pageKeys = ["about","dealers","events","factory","faq","gallery","inventory","landing","license","news","privacy-policy","site-header","testimonials","vehicles"] as const;
export type PageKey = typeof pageKeys[number];

export const pageLoaders: Record<string, () => Promise<unknown>> = {
    "about": () => import('./pages/about').then(m => m.default),
    "dealers": () => import('./pages/dealers').then(m => m.default),
    "events": () => import('./pages/events').then(m => m.default),
    "factory": () => import('./pages/factory').then(m => m.default),
    "faq": () => import('./pages/faq').then(m => m.default),
    "gallery": () => import('./pages/gallery').then(m => m.default),
    "inventory": () => import('./pages/inventory').then(m => m.default),
    "landing": () => import('./pages/landing').then(m => m.default),
    "license": () => import('./pages/license').then(m => m.default),
    "news": () => import('./pages/news').then(m => m.default),
    "privacy-policy": () => import('./pages/privacy-policy').then(m => m.default),
    "site-header": () => import('./pages/site-header').then(m => m.default),
    "testimonials": () => import('./pages/testimonials').then(m => m.default),
    "vehicles": () => import('./pages/vehicles').then(m => m.default),
};

export const entityKeysByType: Record<string, readonly string[]> = {
    "subVehicles": ["cobra-mkii-289","cobra-mkiii-427","corvette-grand-sport","gt40","limited-editions","shelby","shelby-daytona-coupe"],
    "vehicleDetails": ["cobra-mkii-fia","cobra-mkii-slab-side","cobra-mkiii","cobra-mkiii-30th-anniversary","cobra-mkiii-e","cobra-mkiii-r","cobra-mkiii-roadster","corvette-grand-sport","future-40","gt40-50th-anniversary","gt40-60th-anniversary","gt40-mki","gt40-mkii","shelby-289-fia-csx7000","shelby-289-street-csx8000","shelby-427-s-c-csx6000","shelby-cobra-427-s-c-60th-anniversary","shelby-cobra-super-snake","shelby-csx2000-bondurant-tribute-289","shelby-csx2900","shelby-daytona-coupe","shelby-daytona-coupe-60th-anniversary","shelby-gt40"],
    "galleryCategories": ["gt40-black","gt40-blue","gt40-gulf-dark-blue","gt40-gulf-light-blue","gt40-ken-miles-livery","gt40-red","gt40-silver","mkiii-black","mkiii-blue","mkiii-red","mkiii-yellow","superformance-cobra-mkii","superformance-cobra-mkiii","superformance-gt40"],
};

export function hasPage(key: string): boolean {
    return key in pageLoaders;
}

export function hasEntity(type: string, key: string): boolean {
    return entityKeysByType[type]?.includes(key) ?? false;
}

// Dynamic imports use literal template prefixes (not fully dynamic paths) so
// webpack can enumerate per-type chunk candidates at build time. Adding a new
// entity type means adding a case here AND to ENTITY_TYPES in the generator.
export function loadEntity(type: string, key: string): Promise<unknown> | null {
    if (!hasEntity(type, key)) return null;
    switch (type) {
        case 'subVehicles':
            return import(`./entities/subVehicles/${key}`).then(m => m.default);
        case 'vehicleDetails':
            return import(`./entities/vehicleDetails/${key}`).then(m => m.default);
        case 'galleryCategories':
            return import(`./entities/galleryCategories/${key}`).then(m => m.default);
        default:
            return null;
    }
}
